'use strict';

import React from 'react';
import Api from '../../../api/Api';

import { connect } from 'react-redux';

import Alert from '../../../components/Alert';
import Loader from '../../../components/Loader';
import { FormattedMessage, injectIntl } from 'react-intl';
import { selectIsHpa } from '../../../data/hpa/selectors';
import PersonForm from './PersonForm';

// eslint-disable-next-line no-undef
const { id: module_id } = module;

class Person extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null,
    };
  }

  // validation happens in the view component
  save = (field, value) => {
    this.setState({ status: null });
    if (field === 'email') {
      Api.updateEmailInfo({ payload: value })
        .then(() => this.cascadeUpdateUserInfo())
        .catch((err) => {
          console.log(err);
          this.setState({
            status: 'error',
          });
        });
    } else if (field === 'phone') {
      Api.updatePhoneInfo({ payload: value })
        .then(() => this.cascadeUpdateUserInfo())
        .catch((err) => {
          console.log(err);
          this.setState({
            status: 'error',
          });
        });
    }
  };

  cascadeUpdateUserInfo() {
    return this.props.updateUserInfo().then(() => {
      this.setState({
        status: 'OK',
      });
    });
  }

  render() {
    const { person } = this.props;

    !this.state && <Loader />;

    const statusMessage = [];
    if (this.state.status === 'OK') {
      statusMessage.push(
        <Alert
          type="info"
          key="OK"
          dismiss={{
            timeout: true,
            func: () => this.setState({ status: null }),
          }}
        >
          <FormattedMessage id={`${module_id}.status.${this.state.status}`} />
        </Alert>
      );
    } else if (this.state.status !== null) {
      statusMessage.push(
        <Alert key={this.state.status}>
          <FormattedMessage id={`${module_id}.status.${this.state.status}`} />
        </Alert>
      );
    }

    return (
      <PersonForm person={person} status={statusMessage} onSubmit={this.save} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isHpa: selectIsHpa(state),
  };
};

export default connect(mapStateToProps)(injectIntl(Person));
